export default __webpack_public_path__ + "static/media/icfront.b96ce645.svg";